const Welcome = () => {
    return (
        <div className="Welcome">
            <h1 className="Welcome__Title">¡Bienvenid@ aficionad@!</h1>
            <p className="Welcome__Subtitle Welcome__Text--Center">Nos encanta verte por aquí</p>
            <p className="Welcome__Text Welcome__Text--SpaceUp">Te invitamos a participar en las dinámicas que tenemos preparadas para tí.</p>
            <p className="Welcome__Icon"><i className="bi bi-controller"></i></p>
            {/* <p className="Welcome__Icon"><i class="bi bi-file-play"></i></p> */}
            <p className="Welcome__Text">¡No te preocupes!</p>
            <p className="Welcome__Text">Las dinámicas te aparecerán de manera automática</p>
            <p className="Welcome__Text Welcome__Text--Highlight"><i className="bi bi-exclamation-triangle"></i> Solamente permanece en la página</p>
        </div>
    )
}

export { Welcome };